"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./OptionExample.css");
var __1 = require("../../../../");
var icons = require("./../../../../../styles/att-icons.css");
var LabelProps_1 = require("../../../Label/LabelProps");
var OptionExample = /** @class */ (function (_super) {
    __extends(OptionExample, _super);
    function OptionExample(props) {
        return _super.call(this, props) || this;
    }
    OptionExample.prototype.render = function () {
        var imageProps = {
            data: { url: this.props.data.imageUrl },
            options: { alt: 'att logo', height: '40', width: 'auto' },
        };
        var isDecodingNeeded = this.props.data.isDecodingRequired ? this.props.data.isDecodingRequired : false;
        var labelProps = {
            data: { text: this.props.data.text, isDecodingRequired: isDecodingNeeded },
            options: { size: LabelProps_1.LabelSizes.XSMALL },
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.usmContainer, "data-test-id": this.props.testId },
                React.createElement("div", { className: styles.usmImage },
                    React.createElement(__1.Image, __assign({}, imageProps))),
                React.createElement("div", { className: styles.usmLabel },
                    React.createElement(__1.Label, __assign({}, labelProps))),
                this.props && this.props.isSelected &&
                    React.createElement("i", { className: [icons.attIcon, icons.attIconCheck, styles.usmCheckmark].join(' ') }))));
    };
    return OptionExample;
}(React.Component));
exports.default = OptionExample;
//# sourceMappingURL=OptionExample.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/OptionExample/OptionExample.js
// module id = 1252
// module chunks = 8